// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1-d3V","file":"styles_file__2IFYo"};